<template>
    <div class="page-container">
      <div class="settings-form">
        <h2 class="page-title">商品挂载分类管理</h2>
  
        <!-- 搜索区域 -->
        <div class="search-bar">
          <el-input v-model="searchForm.name" placeholder="请输入分类名称" clearable size="large"
            style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
            <template #prefix>
              <el-icon>
                <Search />
              </el-icon>
            </template>
          </el-input>
  
          <el-button type="primary" size="large" @click="handleSearch">
            <el-icon>
              <Search />
            </el-icon>
            搜索
          </el-button>
  
          <el-button type="success" size="large" @click="openAddDialog" style="float: right">
            <el-icon>
              <Plus />
            </el-icon>
            新增分类
          </el-button>
        </div>
  
        <!-- 分类列表 -->
        <el-table :data="categoryList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="name" label="分类名称" width="180" />
          <el-table-column prop="notes" label="备注" />
          <el-table-column prop="create_time" label="创建时间" width="180" />
          <el-table-column prop="update_time" label="更新时间" width="180" />
  
          <!-- 新增查看商品列 -->
          <el-table-column label="商品列表" width="150" fixed="right">
            <template #default="scope">
              <el-button type="info" size="small" @click="openRecordDialog(scope.row)">
                <el-icon>
                  <View />
                </el-icon>
                查看商品
              </el-button>
            </template>
          </el-table-column>
  
          <el-table-column label="操作" width="180" fixed="right">
            <template #default="scope">
              <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
                <el-icon>
                  <Edit />
                </el-icon>
                编辑
              </el-button>
              <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
                <el-icon>
                  <Delete />
                </el-icon>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <!-- 分页组件 -->
        <div class="pagination-container">
          <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
            :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
            @size-change="fetchCategoryList" @current-change="fetchCategoryList" />
        </div>
      </div>
  
      <!-- 新增查看商品对话框 -->
      <el-dialog v-model="recordDialogVisible" :title="recordDialogTitle" width="60%" top="5vh"
        :close-on-click-modal="false">
        <MountingRecordView v-if="recordDialogVisible" :shop-id="currentShopId" :store-id="userInfo.id" />
      </el-dialog>
  
      <!-- 新增/编辑对话框 -->
      <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">
        <el-form ref="categoryForm" :model="categoryForm" label-width="120px" :rules="formRules">
          <el-form-item label="分类名称" prop="name">
            <el-input v-model="categoryForm.name" placeholder="请输入分类名称" size="large" />
          </el-form-item>
  
          <el-form-item label="备注信息">
            <el-input v-model="categoryForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
  
        <template #footer>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitCategoryForm">确认</el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import config from '@/config.js';
  import Cookies from 'js-cookie';
  import {
    Search, Plus, Edit, Delete, View
  } from '@element-plus/icons-vue'
  import MountingRecordView from '@/components/MountingShopRecordView.vue'
  
  export default {
    name: 'MountingShopGz',
    components: { Search, Plus, Edit, Delete, View, MountingRecordView },
    data() {
      return {
        loading: false,
        dialogVisible: false,
        recordDialogVisible: false,
        dialogTitle: '新增分类',
        recordDialogTitle: '',
        isEditMode: false,
        currentShopId: null,
        searchForm: {
          name: ''
        },
        categoryForm: {
          id: null,
          name: '',
          notes: ''
        },
        formRules: {
          name: [
            { required: true, message: '请输入分类名称', trigger: 'blur' }
          ]
        },
        categoryList: [],
        pagination: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      }
    },
    computed: {
      userInfo() {
        return JSON.parse(Cookies.get('user_info') || '{}')
      }
    },
    mounted() {
      this.fetchCategoryList();
    },
    methods: {
      // 打开商品记录对话框
      openRecordDialog(row) {
        this.currentShopId = row.id;
        this.recordDialogTitle = `${row.name} - 商品列表`;
        this.recordDialogVisible = true;
      },
      // 获取分类列表
      async fetchCategoryList() {
        this.loading = true;
        try {
          const params = {
            action: this.searchForm.name ? 'search' : 'list',
            store_id: this.userInfo.id,
            page: this.pagination.page,
            page_size: this.pagination.pageSize
          };
  
          if (this.searchForm.name) {
            params.keyword = this.searchForm.name;
          }
  
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/shop_mounting_management.php`,
            params
          );
  
          if (data.data) {
            this.categoryList = data.data;
            this.pagination.total = data.pagination?.total || data.data.length;
          }
        } catch (error) {
          this.$message.error('获取分类列表失败');
          console.error('获取分类列表错误:', error);
        } finally {
          this.loading = false;
        }
      },
      // 处理搜索
      handleSearch() {
        this.pagination.page = 1;
        this.fetchCategoryList();
      },
      // 打开新增对话框
      openAddDialog() {
        this.dialogTitle = '新增分类';
        this.isEditMode = false;
        this.categoryForm = {
          id: null,
          name: '',
          notes: ''
        };
        this.dialogVisible = true;
      },
      // 打开编辑对话框
      openEditDialog(row) {
        this.dialogTitle = '编辑分类';
        this.isEditMode = true;
        this.categoryForm = {
          id: row.id,
          name: row.name,
          notes: row.notes
        };
        this.dialogVisible = true;
      },
      // 提交表单（新增/编辑）
      submitCategoryForm() {
        this.$refs.categoryForm.validate(async (valid) => {
          if (valid) {
            try {
              const action = this.isEditMode ? 'update' : 'add';
              const { data } = await axios.post(
                `${config.BASE_URL}/shop/api/shop_mounting_management.php`,
                {
                  action,
                  ...this.categoryForm,
                  store_id: this.userInfo.id
                }
              );
  
              if (data.success) {
                this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
                this.dialogVisible = false;
                this.fetchCategoryList();
              } else {
                this.$message.error(data.error || '操作失败');
              }
            } catch (error) {
              const errorMsg = error.response?.data?.error || error.message || '操作失败';
              this.$message.error(`操作失败: ${errorMsg}`);
              console.error('表单提交错误:', error);
            }
          }
        });
      },
      // 删除分类
      async handleDelete(id) {
        this.$confirm('确定要删除该分类吗？删除后关联的商品记录也将被删除', '警告', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/shop_mounting_management.php`,
              {
                action: 'delete',
                id: id,
                store_id: this.userInfo.id
              }
            );
  
            if (data.success) {
              this.$message.success('删除成功');
              this.fetchCategoryList();
            } else {
              this.$message.error(data.error || '删除失败');
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '删除失败';
            this.$message.error(`删除失败: ${errorMsg}`);
            console.error('删除错误:', error);
          }
        }).catch(() => { });
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .page-container {
    padding: 0px;
  }
  
  .settings-form {
    max-width: 95%;
    margin: 0 auto;
    padding: 32px 40px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  }
  
  .page-title {
    font-size: 24px;
    color: #1f2937;
    margin-bottom: 32px;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0.5px;
  }
  
  .search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding: 16px;
    background: #f8fafc;
    border-radius: 8px;
  }
  
  .pagination-container {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
  
  /* 表格样式优化 */
  .el-table {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
  
    :deep(.el-table__header) th {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 600;
    }
  
    :deep(.el-table__body) tr:hover>td {
      background-color: #f0f7ff !important;
    }
  }
  
  /* 操作按钮样式 */
  .el-button {
    display: inline-flex;
    align-items: center;
  
    .el-icon {
      margin-right: 5px;
    }
  }
  
  /* 对话框样式优化 */
  :deep(.el-dialog) {
    border-radius: 12px;
  
    .el-dialog__header {
      padding: 20px 24px;
      border-bottom: 1px solid #ebeef5;
      margin-right: 0;
  
      .el-dialog__title {
        font-weight: 600;
        color: #1f2937;
      }
    }
  
    .el-dialog__body {
      padding: 24px;
    }
  
    .el-dialog__footer {
      padding: 16px 24px;
      border-top: 1px solid #ebeef5;
    }
  }
  
  /* 表单验证提示样式 */
  :deep(.el-form-item__error) {
    font-size: 12px;
    padding-top: 4px;
  }
  </style>